import { DocumentLegalType } from '@api/types/enums';

export const categoryOptions = ['evidence', 'legal', 'shared'];

export const documentLegalTypesList: { value: DocumentLegalType; labelKey: string }[] = [
  { value: DocumentLegalType.offer, labelKey: 'legal_documents_offer' },
  { value: DocumentLegalType.engagement_letter, labelKey: 'legal_documents_engagement_letter' },
  {
    value: DocumentLegalType.letter_of_acceptance,
    labelKey: 'legal_documents_letter_of_acceptance',
  },
  {
    value: DocumentLegalType.letter_of_representation,
    labelKey: 'legal_documents_letter_of_representation',
  },
  { value: DocumentLegalType.audit_report, labelKey: 'legal_documents_audit_report' },
  { value: DocumentLegalType.invoice, labelKey: 'legal_documents_invoice' },
];
